import React from 'react';
import { Check, CheckCheck, Eye, Euro } from 'lucide-react';
import { HaekchenStufen } from '../HaekchenStufen';

// Rechnung: gesendet → zugestellt → geöffnet (im Portal gesehen oder PDF angesehen) → bezahlt
export const RechnungHaekchen = ({ r }) => {
  const bezahlt = r.status === 'bezahlt';
  const teil = !bezahlt && r.offen != null && r.offen < r.betrag;
  return (
    <HaekchenStufen testId={`re-haekchen-${r.id}`} stufen={[
      ['gesendet', r.mail_gesendet_am ? 'Gesendet' : 'Im Portal bereitgestellt', Check, r.mail_gesendet_am || r.created_at],
      ['zugestellt', 'Zugestellt', CheckCheck, r.zugestellt_am],
      ['geoeffnet', teil ? 'Teilweise bezahlt' : 'Geöffnet', Eye, r.pdf_angesehen_am || r.abgerufen_am || (teil ? true : null)],
      ['bezahlt', 'Bezahlt', Euro, bezahlt ? (r.bezahlt_am || true) : null],
    ]} />
  );
};

export default RechnungHaekchen;
